module.exports = __webpack_public_path__ + "static/media/loader.1ccc4c7c.svg";